<template>
  <div class="content">
    <div class="vi">
      <div v-if="!hasData()"> 게시글 없음</div>
      <div class="v_image sup_img" v-else>
        <img class="v_img" :src="returnImage()">
      </div>
    </div>
  </div>
</template>

<script>
    import imageOption from "@/mixins/imageOption";
    import util from "@/mixins/util";
    export default {
        name: "SupportLayout",
        mixins: [imageOption,],
        components: {},
        props: {
            infoData: {},
        },
        data() {
            return {

            }
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {

        },
        methods: {
            hasData(){
                return !util.isEmpty(this.infoData)
            },
            returnImage(){
              return this.infoData.org_url
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>